/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Ponedjeljak", "Utorak", "Srijeda", "\u010Cetvrtak", "Petak", "Subota", "Nedjelja"], e = ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], d = "Godine", t = "Godina", r = "Mjesec", n = "Sedmica", s = "Dan", o = "Danas", i = "Nema doga\u0111aja", j = "Cijeli dan", l = "Obri\u0161i", m = "Kreiraj doga\u0111aj", M = "dddd D MMMM YYYY", y = { weekDays: a, months: e, years: "Godine", year: "Godina", month: "Mjesec", week: "Sedmica", day: "Dan", today: "Danas", noEvent: "Nema doga\u0111aja", allDay: "Cijeli dan", deleteEvent: "Obri\u0161i", createEvent: "Kreiraj doga\u0111aj", dateFormat: "dddd D MMMM YYYY" };
export {
  j as allDay,
  m as createEvent,
  M as dateFormat,
  s as day,
  y as default,
  l as deleteEvent,
  r as month,
  e as months,
  i as noEvent,
  o as today,
  n as week,
  a as weekDays,
  t as year,
  d as years
};
